// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Navigation-module__navigation___3KkB5","sections":"Navigation-module__sections___nGITc","section":"Navigation-module__section___2GW5_"};